import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import * as yup from "yup";
import Divider from "@material-ui/core/Divider";
import { Alert } from "@material-ui/lab";
import DefaultForm from "../../../components/default-form";
import { doFetch } from "../../../services/fetch/fetch.actions";
import { fetchRole } from "../../../services/politician/profile-service";
import UserForm from "../../../components/user-form";

const schema = yup.object().shape({
  fnr: yup
    .string()
    .matches(/^[0-9]{11}$/, "Fødselsnummer må være 11 siffer")
    .required("Fødselsnummer er påkrevd"),
  epost: yup.string().email().required("Epost påkrevd"),
  fornavn: yup.string().required("Fornavn er påkrevd"),
  etternavn: yup.string().required("Etternavn er påkrevd"),
  adresse: yup.string().required("Adresse påkrevd"),
  parti: yup.string().required("Parti påkrevd"),
  gender: yup.string().required("Kjønn påkrevd"),
  postnr: yup
    .number()
    .typeError("Kan ikke inneholde tekst")
    .required("Postnummer påkrevd"),
  poststed: yup.string().required("Poststed påkrevd"),
  tlfprivat: yup
    .string()
    .matches(/^[0-9]{1,8}$/, "Telefonnummer ikke gyldig")
    .required("Telefonnummer påkrevd"),
  arbeidssted: yup.string(),
  bankkontonummer: yup.number().required("Bankkontonr. påkrevd"),
  generalInfo: yup.string(),
});

class EnabledPolitician extends Component {
  componentDidMount() {
    const {
      me: { fetched, fetching },
      dispatch,
    } = this.props;
    if (!fetched && fetching) {
      dispatch(
        doFetch(
          "ME",
          fetchRole().then((res) => {
            if (!res.ok) throw res;
            return res.json();
          }),
        ),
      );
    }
  }

  render() {
    const {
      me: { payload: me, fetched, error, fetching },
      classes,
    } = this.props;

    return (
      <div className={classes.root}>
        <Typography variant="h4" color="primary" gutterBottom>
          Politikerbasen i Trondheim kommune
        </Typography>
        <div className={classes.flex}>
          <Typography variant="h5" color="primary">
            Min profil
          </Typography>

          <Alert severity="info">
            <Typography variant="body1" color="textPrimary">
              Du finner <a href="/v2">Åpenhetsregisteret her.</a>
            </Typography>
          </Alert>

          {/* <Button
            onClick={() => this.setState({ editPolitician: true })}
            variant="contained"
            disabled={editPolitician}
            color="primary"
          >
            Administrer opplysninger
          </Button> */}
        </div>
        <Divider className={classes.divider} />
        {
          fetched &&
            !error &&
            me.roles &&
            (me.roles.includes("politician") ? (
              <DefaultForm
                key="static-form"
                initialValues={{
                  parti:
                    (me.parties && me.parties.length > 0 && me.parties[0].id) ||
                    "",
                  fnr: "***********",
                  fornavn: me.givenName,
                  etternavn: me.familyName,
                  adresse: me.streetAddress,
                  gender: me.sex?.toLowerCase() === "m" ? "Mann" : "Kvinne",
                  postnr: me.zipCode,
                  poststed: me.city,
                  tlfprivat: me.phone,
                  arbeidssted: me.workPlace,
                  epost: me.email,
                  bankkontonummer: me.bankAccount,
                  generalInfo: me.generalInfo,
                }}
                schema={schema}
                onSubmit={() => {}}
                hideButtons
                disabledFields={{
                  fornavn: true,
                  etternavn: true,
                  adresse: true,
                  postnr: true,
                  poststed: true,
                  fnr: true,
                  parti: true,
                  gender: true,
                  tlfprivat: true,
                  arbeidssted: true,
                  epost: true,
                  bankkontonummer: true,
                  generalInfo: true,
                }}
              />
            ) : (
              <UserForm
                key="static-form"
                initialValues={{
                  fnr: "***********",
                  fornavn: me.givenName,
                  etternavn: me.familyName,
                  tlfprivat: me.phone,
                  epost: me.email,
                }}
                schema={{}}
                onSubmit={() => {}}
                hideButtons
                disabledFields={{
                  fornavn: true,
                  etternavn: true,
                  fnr: true,
                  tlfprivat: true,
                  epost: true,
                }}
              />
            ))
          /*   editPolitician && (
            <DefaultForm
              key="dynamic-form"
              schema={schema}
              initialValues={{
                parti: me.party.id,
                fnr: '***********',
                fornavn: me.name.givenName,
                etternavn: me.name.familyName,
                adresse: me.politicianData.address.streetAddress,
                gender: me.politicianData.sex === 'm' ? 'Mann' : 'Kvinne',
                postnr: me.politicianData.address.zipCode,
                poststed: me.politicianData.address.city,
                tlfprivat: me.politicianData.phone,
                arbeidssted: me.politicianData.work.workPlace,
                epost: me.politicianData.work.email,
                bankkontonummer: me.politicianData.bankAccount,
                generalInfo: me.politicianData.generalInfo,
                stilling: me.party.role,
              }}
              onSubmit={(v) => {
                console.log(v);
              }}
              handleCancel={() => this.setState({ editPolitician: false })}

            />
          ), */
        }
        {fetching && (
          <DefaultForm
            initialValues={{
              parti: "",
              fnr: "",
              fornavn: "",
              etternavn: "",
              adresse: "",
              gender: "Mann",
              postnr: "",
              poststed: "",
              tlfprivat: "",
              arbeidssted: "",
              epost: "",
              bankkontonummer: "",
              generalInfo: "",
            }}
            isLoading
            hideButtons
            disabledFields={{
              fornavn: true,
              etternavn: true,
              adresse: true,
              postnr: true,
              poststed: true,
              fnr: true,
              parti: true,
              gender: true,
              tlfprivat: true,
              arbeidssted: true,
              epost: true,
              bankkontonummer: true,
              generalInfo: true,
            }}
          />
        )}
      </div>
    );
  }
}

EnabledPolitician.propTypes = {
  me: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

const styles = () => ({
  root: {
    maxWidth: "50rem",
    marginBottom: "4rem",
  },
  flex: {
    display: "flex",
    "flex-direction": "column",
    gap: "1rem",
    justifyContent: "space-between",
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "0.2rem",
  },
});

const mapStateToProps = ({ me }) => ({ me });

export default connect(mapStateToProps)(
  withRouter(withStyles(styles)(EnabledPolitician)),
);
